import * as React from 'react';

export const uaFlagContent: JSX.Element = (
    <>
        <g clip-path='url(#clip0_55_3147)'>
            <rect
                width='28'
                height='20'
                rx='4'
                fill='#FECA00'
            />
            <mask
                id='mask0_55_3147'
                style={{ maskType: 'alpha' }}
                maskUnits='userSpaceOnUse'
                x='0'
                y='0'
                width='28'
                height='20'
            >
                <path
                    d='M0 4C0 1.79086 1.79086 0 4 0H24C26.2091 0 28 1.79086 28 4V16C28 18.2091 26.2091 20 24 20H4C1.79086 20 0 18.2091 0 16V4Z'
                    fill='#D9D9D9'
                />
            </mask>
            <g mask='url(#mask0_55_3147)'>
                <path
                    d='M0 0H28V10.6667H0V0Z'
                    fill-rule='evenodd'
                    clip-rule='evenodd'
                    fill='#3195F9'
                />
            </g>
        </g>
        <defs>
            <clipPath id='clip0_55_3147'>
                <rect
                    width='28'
                    height='20'
                    rx='4'
                    fill='white'
                />
            </clipPath>
        </defs>
    </>
);
